/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: aukbrhkegRkQ6KizvhdUPT

import {
  createStyleTokensProvider,
  createUseStyleTokens,
} from "@plasmicapp/react-web";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: aukbrhkegRkQ6KizvhdUPT/projectModule

import projectcss from "../PP__plasmickit_left_pane.module.css"; // plasmic-import: aukbrhkegRkQ6KizvhdUPT/projectcss

const data = {
  base: projectcss.plasmic_tokens,
  varianted: [],
};

export const _useStyleTokens = createUseStyleTokens(data, _useGlobalVariants);

export const StyleTokensProvider = createStyleTokensProvider(
  data,
  _useGlobalVariants
);
